import type { Transition, Variants } from "motion/react";

// Movimiento de la app con Motion (https://motion.dev). Resortes suaves y cortos, como en iOS:
// dan vida sin hacer esperar. `MotionConfig reducedMotion="user"` (AppShell) los desactiva cuando el
// sistema pide reducir el movimiento.

/** Resorte estándar: selección que se desliza, paneles, menús. */
export const spring: Transition = { type: "spring", stiffness: 420, damping: 36, mass: 0.9 };

/** Resorte para la barra lateral y desplazamiento de contenido (motion.dev) */
export const sidebarSpring: Transition = {
  type: "spring",
  stiffness: 350,
  damping: 34,
  mass: 0.8,
};

/** Resorte rápido y reactivo: navegación entre opciones de menú y hover instantáneo. */
export const fastSpring: Transition = { type: "spring", stiffness: 850, damping: 45, mass: 0.35 };

/**
 * Resaltado que sigue al teclado o al cursor en listas (búsqueda): sobreamortiguado, sin rebote,
 * se asienta en ~150 ms. Como Spotlight o Raycast: rápido pero sin saltos.
 */
export const highlight: Transition = { type: "spring", stiffness: 700, damping: 50, mass: 0.5 };

/** Resorte más suave para entradas de contenido. */
export const gentle: Transition = { type: "spring", stiffness: 260, damping: 30 };

/** Entrada de una página al navegar. */
export const pageEnter = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0 },
  transition: gentle,
};

/** Contenedor que escalona la entrada de sus hijos. */
export const stagger: Variants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.05, delayChildren: 0.04 } },
};

/** Hijo de `stagger`: sube y aparece. */
export const riseIn: Variants = {
  hidden: { opacity: 0, y: 14, scale: 0.985 },
  show: { opacity: 1, y: 0, scale: 1, transition: gentle },
};

/** Menús y listas que se despliegan desde un control. */
export const popIn = {
  initial: { opacity: 0, y: -6, scale: 0.97 },
  animate: { opacity: 1, y: 0, scale: 1 },
  exit: { opacity: 0, y: -4, scale: 0.98, transition: { duration: 0.12 } },
  transition: spring,
};
